const PRODUCT_TOUR_KEY = 'hasSeenProductTour';
const FIRST_CASE_COMPLETED_KEY = 'simPLAB2_firstCaseCompleted';

export const isFirstTimeUser = (): boolean => {
  return localStorage.getItem(PRODUCT_TOUR_KEY) === null;
};

export const markFirstTimeUserComplete = (): void => {
  localStorage.setItem(PRODUCT_TOUR_KEY, 'true');
};

export const isOnboardingCompleted = (): boolean => {
  return localStorage.getItem(PRODUCT_TOUR_KEY) === 'true';
};

export const markOnboardingComplete = (): void => {
  localStorage.setItem(PRODUCT_TOUR_KEY, 'true');
};

export const isFirstCaseCompleted = (): boolean => {
  return localStorage.getItem(FIRST_CASE_COMPLETED_KEY) === 'true';
};

export const markFirstCaseComplete = (): void => {
  localStorage.setItem(FIRST_CASE_COMPLETED_KEY, 'true');
};

export const resetFirstTimeUserState = (): void => {
  localStorage.removeItem(PRODUCT_TOUR_KEY);
  localStorage.removeItem(FIRST_CASE_COMPLETED_KEY);
}; 